// extracted by mini-css-extract-plugin
export default {"bottom_affix":"index_bottom_affix_t9quq","backToTop":"index_backToTop_l7N4Z","floatAd":"index_floatAd_UrZsC"};